import clsx from 'clsx';
import type { JSX } from 'react';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

const BADGE_CLASSNAME: Record<BadgeTone, string> = {
  neutral:
    'border-surface-subtle bg-surface-subtle text-text-primary/80 dark:border-surface-navy/60 dark:bg-surface-navy/70 dark:text-white/80',
  info: 'border-brand-primary/30 bg-brand-primary/10 text-brand-primary',
  success: 'border-emerald-300/60 bg-emerald-100 text-emerald-800',
  warning: 'border-amber-300/60 bg-amber-100 text-amber-800',
  danger: 'border-rose-300/60 bg-rose-100 text-rose-800',
};

export interface StatusBadgeProps {
  label: string;
  tone?: BadgeTone;
  secondaryLabel?: string | null;
  secondaryTone?: BadgeTone;
  className?: string;
}

export function StatusBadge({
  label,
  tone = 'info',
  secondaryLabel,
  secondaryTone = 'warning',
  className,
}: StatusBadgeProps): JSX.Element {
  return (
    <div className={clsx('flex flex-wrap items-center gap-1', className)}>
      <span
        className={clsx(
          'inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wide',
          BADGE_CLASSNAME[tone],
        )}
      >
        {label}
      </span>
      {typeof secondaryLabel === 'string' && secondaryLabel.length > 0 ? (
        <span
          className={clsx(
            'inline-flex items-center rounded-full border px-2.5 py-1 text-[0.65rem] font-semibold uppercase tracking-wide',
            BADGE_CLASSNAME[secondaryTone],
          )}
        >
          {secondaryLabel}
        </span>
      ) : null}
    </div>
  );
}
